import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.routes.length
    ? _c("div", { staticClass: "sidebar" }, [
        _c(
          "ul",
          { staticClass: "sidebar__list ma-0 pa-0" },
          [
            _vm._l(_vm.routes, function (route, index) {
              return [
                _c("li", { key: index, staticClass: "sidebar__item mb-2" }, [
                  _c(
                    "a",
                    {
                      class: [
                        "sidebar__link text-body-1 text--text d-flex align-items-center text-decoration-none px-2 py-2 rounded",
                        {
                          "sidebar__link_active font-weight-600":
                            _setup.isActive(route),
                        },
                        { "primary--text": _setup.isActive(route) },
                      ],
                      attrs: { href: route.path },
                    },
                    [
                      route.icon
                        ? _c(
                            VIcon,
                            {
                              staticClass: "icon-secondary--text mr-4",
                              attrs: { size: "20" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(route.icon) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(
                        "\n          " +
                          _vm._s(_setup.t(route.label, _setup.options)) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  route.items?.length
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "sidebar__list-inner mt-1 ml-4 d-flex flex-column gc-1",
                        },
                        _vm._l(route.items, function (item) {
                          return _c(
                            "a",
                            {
                              key: item.href,
                              staticClass:
                                "sidebar__item-inner text-body-2 text-secondary--text d-flex align-items-center text-decoration-none",
                              attrs: { href: item.href },
                            },
                            [
                              _c(
                                VIcon,
                                {
                                  staticClass: "icon-secondary--text mr-1",
                                  attrs: { size: "20" },
                                },
                                [
                                  _vm._v(
                                    "\n              ui-icon-arrow-right\n            "
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_setup.t(item.label, _setup.options)) +
                                  "\n          "
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]),
              ]
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }